module.exports = __webpack_public_path__ + "static/media/hm.a3c80686.svg";